export enum TypeDocument{
  TESIS = 'TÉSIS AISLADAS Y DE JURISPRUDENCIA',
  SENTENCIA = 'SENTENCIA',
  PRIVADO = 'PRIVADO',
  LIBRE = 'LIBRE',
  ACUERDOS = 'ACUERDOS',
  AMNISTIA = "AMNISTIA"
}
